import React from "react";
import { Container } from "react-bootstrap";
import { ThirdSec } from "../HomeComponents/ThirdSec";

export const WhyMeToWork = () => {
  return (
    <view>
      <Container>
        <div class="text-center py-3">
          <h2 class="text-5xl robot">Why Me2Works</h2>
        </div>
      </Container>
      <ThirdSec />
    </view>
  );
};
